import React from "react";
import { Link } from "react-router-dom";
import sliderImage1 from "./images/istockphoto-1227389686-2048x2048.jpg";

const Header = () => {
  const sliderData = [
    {
      image: sliderImage1,
      title: "A Perfect Learning Center",
      subtitle: "For Your Kids",
      description:
        "Greatness begins with the right guidance – discover a tutor who will awaken your child's true potential.",
    },
  ];

  return (
    <section
      className="relative h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${sliderData[0].image})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
        <div className="text-center px-6 md:px-10 max-w-4xl text-white">
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight drop-shadow-md">
            {sliderData[0].title}
            <br />
            <span className="text-yellow-400">{sliderData[0].subtitle}</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-gray-200">
            {sliderData[0].description}
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Link
              to="/About2"
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-2 px-6 rounded-full transition duration-300 shadow-lg"
            >
              Read More
            </Link>
            <Link
              to="/Contact"
              className="bg-white hover:bg-gray-100 text-black font-semibold py-2 px-6 rounded-full transition duration-300 shadow-lg"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
